import { Badge } from "@/components/ui/badge";
import type { WhoPayWhoViewProps } from "@/ui/view-props";
import { WhoPayWhoClassicView } from "@/ui/v1/WhoPayWhoClassicView";

export function WhoPayWhoModernView(props: WhoPayWhoViewProps) {
  return (
    <div className="space-y-3">
      <WhoPayWhoClassicView {...props} hideHeader={true} />
    </div>
  );
}
